import Helmet from 'react-helmet'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { removeHtmlTags } from '../../helpers/string'
import { WebsiteJsonLd } from './Website'
import { OrganizationJsonLd } from './Organization'
import { HtmlTagSchemaMarkup } from './HtmlTagSchemaMarkup'

export default function MetaTags({ page, data }) {
    const intl = useIntl()
    const isDynamic = useMemo(() => {
        const dynamicPages = ['blog_slug', 'digital_slug', 'job_slug', 'apply'];
        return dynamicPages.includes(page);
    }, [page])

    const metaTitle = useMemo(() => {

        if (data?.seo_title) {
            return data.seo_title
        }

        if (page === 'job') {
            return intl.formatMessage({ id: `portfolio.jobs.pole.${data?.business_unit}.metas.title` })
        }

        if (page === 'digital') {
            return intl.formatMessage({ id: `portfolio.digital.pole.${data?.business_unit}.metas.title` })
        }

        if (!isDynamic) {
            return intl.formatMessage({ id: `metas.${page}.title` })
        }
        if (page === 'apply') {
            return intl.formatMessage({ id: `metas.apply.prefix` }) + data.title
        }

        return data.title
    }, [isDynamic, data])

    const metaDescription = useMemo(() => {

        if (data?.seo_description) {
            return data.seo_description
        }

        if (page === 'job') {
            return intl.formatMessage({ id: `portfolio.jobs.pole.${data?.business_unit}.metas.description` })
        }

        if (page === 'digital') {
            return intl.formatMessage({ id: `portfolio.digital.pole.${data?.business_unit}.metas.description` })
        }

        if (!isDynamic) {
            return intl.formatMessage({ id: `metas.${page}.description` })
        }

        const content = removeHtmlTags(data.content)
        return content.substr(0, 197) + '...'
    }, [isDynamic, data])

    const ogImage = useMemo(() => {
        if (page === 'blog_slug' && data?.attachment?.url) {
            return data.attachment.url
        }

        return "https://urbanlinker.fra1.digitaloceanspaces.com/attachments/d254b17d2999899c5c308e04f2e148f1017356c3.png"
    }, [page])

    return (
        <>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            <WebsiteJsonLd />
            <OrganizationJsonLd />
            {isDynamic &&
            <Helmet>
                <meta itemProp="name" content="Urban Linker" />
                <meta itemProp="image" content={ogImage} />

                <meta property="og:type" content="website" />
                <meta name="image" property="og:image" content={ogImage} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image" content={ogImage} />
            </Helmet>}
        </>

    )
}
